//GLOBAL - components from npm
import React, { useEffect, useState } from "react";
//import axios from 'axios';

//STYLES
import "./attach-type-files.css";

//COMPONENTS
import Typography from "../Typography";
import { Tooltippy } from "../../actions/Tippy";

//SERVICES - api, conectors...
import urlIngWeb from "../../actions/urlIngWeb";

//GLOBAL STATE - redux, env...

//ASSETS - icons, images..
import { ReactComponent as IconTrash } from "../../build/images/chatIcons/Trash.svg";
import { ReactComponent as IconClips } from "../../build/images/chatIcons/Clips.svg";
import { ReactComponent as IconDOC } from "../../build/images/type-files/IconDOC.svg";
import { ReactComponent as IconXLS } from "../../build/images/type-files/IconXLS.svg";
import { ReactComponent as IconPDF } from "../../build/images/type-files/IconPDF.svg";
import { ReactComponent as IconPPT } from "../../build/images/type-files/IconPPT.svg";
import { ReactComponent as IconTXT } from "../../build/images/type-files/IconTXT.svg";
import { ReactComponent as IconZIP } from "../../build/images/type-files/IconZIP.svg";

function AttachTypeFiles({
  files,
  setFiles,
  limit = 3,
  type = "insert",
  className,
  download,
  setDeleteFiles,
  deleteFiles,
}) {
  //GENERAL

  //STATES
  const [value, setValue] = useState(0);

  //REDUX - Selectors

  //FUNCTIONS
  const deleteFile = (indexFile, file) => {
    const arrayFiles = [...files];
    const filteredFiles = arrayFiles.filter(
      (file, index) => index !== indexFile + value
    );

    if (value > 0) {
      setValue((value) => value - 1);
    }

    setFiles(filteredFiles);

    const arrayDeleteFiles = deleteFiles;
    if (file.file.id) {
      arrayDeleteFiles.push(file.file.id);
      setDeleteFiles(arrayDeleteFiles);
    }
  };

  const onDownload = (file) => {
    fetch(`${urlIngWeb + file.path_arquivos}`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        a.click();
      });
    });
  };

  const renderTypeIcons = (extension) => {
    switch (extension) {
      case "doc":
      case "docx":
        return <IconDOC />;

      case "xls":
      case "xlsx":
      case "xlsm":
        return <IconXLS />;

      case "pdf":
        return <IconPDF />;

      case "ppt":
      case "pptx":
      case "ppsx":
        return <IconPPT />;

      case "txt":
        return <IconTXT />;

      case "zip":
        return <IconZIP />;

      default:
        return <IconClips />;
    }
  };

  return (
    <>
      <div className={`${className} ${"attach-typefile"} attach-typefiles`}>
        <div className="carousel-attach-list">
          <Tooltippy content={files ? files.name : ""}>
            <div className="carousel-attach-list-file">
              <div
                className={`carousel-attach-list-file__icontype ${
                  files ? files.extension : ""
                }`}
              >
                {files && renderTypeIcons(files.extension)}
              </div>
              {download ? (
                <button onClick={() => onDownload(files)}>
                  <Typography.H5
                    className="carousel-attach-list-file__text"
                    color="primary-dark"
                    weight={500}
                  >
                    {files ? files.name : ""}
                  </Typography.H5>
                </button>
              ) : (
                <Typography.H5
                  className="carousel-attach-list-file__text"
                  color="primary-dark"
                >
                  {files ? files.name : ""}
                </Typography.H5>
              )}
              {type === "insert" && (
                <IconTrash
                  className="carousel-attach-list-file__icon"
                  onClick={() => deleteFile(files)}
                />
              )}
            </div>
          </Tooltippy>
        </div>
      </div>
    </>
  );
}

export default AttachTypeFiles;
